export const placeholderProjectImage = "/images/home/hot-projects/project-generic.svg";

export const errorHandler = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
	const target = e.target as HTMLImageElement;
	// Use pathname to avoid absolute URL comparison issues and add retry protection
	if (!target.src.endsWith(placeholderProjectImage) && !target.dataset.errorHandled) {
		target.dataset.errorHandled = "true";
		target.dataset.originalSrc = target.src;
		target.src = placeholderProjectImage;
		// Ensure srcset is valid: use width descriptors matching Next.js defaults
		const widths = [640, 750, 828, 1080, 1200, 1920, 2048, 3840];
		target.srcset = widths.map(w => `${placeholderProjectImage} ${w}w`).join(", ");
		// Provide a sensible default sizes if none present
		if (!target.sizes) {
			target.sizes = "100vw";
		}
	}
};
